<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <ng-container *ngFor="let item of data.cases">
    <section
      class="check-cases"
      [class.border]="item.isApplicable"
      [attr.id]="item.title"
    >
      <mat-slide-toggle
        [color]="item.isPassed ? 'primary' : 'warn'"
        [(ngModel)]="item.isApplicable"
        (change)="onDataChange()"
        *ngIf="!(readonly || printPreview)"
      >
        <span class="title" [class.error]="item.isApplicable && !item.isPassed"
          ><span>{{ item.section }}. </span> <span>{{ item.title }}</span></span
        >
      </mat-slide-toggle>
      <span
        class="title"
        [class.error]="item.isApplicable && !item.isPassed"
        *ngIf="readonly || printPreview"
        ><span>{{ item.section }}. </span>
        <span>{{ item.title }}</span>
      </span>
      <div class="cases" *ngIf="item.isApplicable">
        <ng-container *ngFor="let c of item.subCases">
          <authority-labs-check-case
            style="display: block"
            [style.margin-right]="margin(item.section, c.section)"
            *ngIf="isParentShown(item.section, c.section)"
            (dataChange)="onDataChange()"
            [printPreview]="printPreview"
            [readonly]="readonly"
            [inspection]="c"
          ></authority-labs-check-case>
        </ng-container>
      </div>
    </section>
  </ng-container>
</main>
